import { Controller, ControllerProps } from "react-hook-form";
import { TextInput, TextInputProps } from "@shltelemedicine/shl-ui-lib";
type TextFormInputProps<T> = Omit<ControllerProps<T>, "render"> & {
  input: TextInputProps;
};

const TextFormInput = <T,>({
  name,
  rules,
  control,
  input,
  ...rest
}: TextFormInputProps<T>) => {
  return (
    <Controller
      {...rest}
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => <TextInput {...field} {...input} />}
    />
  );
};

export default TextFormInput;
